import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useContacts(): RootState["contacts"] {

    const contacts = useSelector<RootState, RootState["contacts"]>(
        ({ contacts }) => contacts
    )

    return contacts
}
